module.exports = __webpack_public_path__ + "img/front_earth_normal.c6a70e2b.png";